import { ReactElement, useCallback, useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { ScanResultComponent } from "../../components/scanresult/scanresult";
import { DocQr, IDocQr } from "../../domain/docqr.domain";
import { DocQrService } from "../../domain/services/docqr.service";
import { buildDocQrRouteUrl } from '../../domain/services/docqrUrl';
import { formatRevisionDateForDisplay, formatRevisionDateForLegacyRoute } from '../../utils/revisionDate';

export function ResultPage() : ReactElement {

    let { werkmaatschappij, projectcode, documentnummer, revisie, revisiedatum } = useParams() as { werkmaatschappij:string, projectcode:string, documentnummer:string, revisie:string, revisiedatum:string};

    if(werkmaatschappij.toUpperCase() === "VSH" 
        || werkmaatschappij.toUpperCase() === "VSHD" 
        || werkmaatschappij.toUpperCase() === "VSHPI"
        || (werkmaatschappij.toUpperCase() === "VHB" && projectcode.toUpperCase() === "SO0223010761")
        || (werkmaatschappij.toUpperCase() === "VHB" && projectcode.toUpperCase() === "TRO0222000262")
        || (werkmaatschappij.toUpperCase() === "VHB" && projectcode.toUpperCase() === "SO0223010762")
        || (werkmaatschappij.toUpperCase() === "VWI" && projectcode.toUpperCase() === "P202038-P")
        )
    {
        var hanabRedirectUrl = buildDocQrRouteUrl(
            'https://docqr.hanab.nl',
            werkmaatschappij,
            projectcode,
            documentnummer,
            revisie,
            formatRevisionDateForLegacyRoute(revisiedatum));

        window.location.href = hanabRedirectUrl;
    }
    
    const [docQr] = useState<IDocQr>(() => new DocQr(new DocQrService()));
    const [apiRevisionDate, setApiRevisionDate] = useState<string | Date | undefined>();

    useEffect(() => {
        setApiRevisionDate(undefined);
        docQr.loadScanResult(werkmaatschappij, projectcode, documentnummer, revisie, revisiedatum);
    }, [docQr, werkmaatschappij, projectcode, documentnummer, revisie, revisiedatum]);

    const onScannedRevisionDateChanged = useCallback((revisionDate: string | Date | undefined) => {
        setApiRevisionDate(revisionDate);
    }, []);

    const displayedRevisionDate = apiRevisionDate ?? revisiedatum;

    return ( 
      
        <main role="main" className="container-fluid">
            <h3>Gescand document</h3>
            <dl className="row">
                <dt className="col-sm-4 col-md-3 col-lg-2">Documentnummer</dt>
                <dd className="col-sm-8 col-md-9 col-lg-10">{documentnummer}</dd>
                <dt className="col-sm-4 col-md-3 col-lg-2">Revisie</dt>
                <dd className="col-sm-8 col-md-9 col-lg-10">{revisie}</dd>
                <dt className="col-sm-4 col-md-3 col-lg-2">Revisiedatum</dt>
                <dd className="col-sm-8 col-md-9 col-lg-10">{formatRevisionDateForDisplay(displayedRevisionDate)}</dd>
            </dl>
            
            <h3>Resultaat van controle</h3>

            <ScanResultComponent
                docQr={docQr}
                scannedDocumentNumber={documentnummer}
                scannedRevision={revisie}
                onScannedRevisionDateChanged={onScannedRevisionDateChanged}
            />
        </main>
    );
}
